import React, { createContext, useState } from 'react'

export const DataContext = createContext()

export const DataProvider = ({ children }) => {
  const [inputOrgid, setInputOrgid] = useState('')
  const [inputLoid, setInputLoid] = useState('')
  console.log('DataProvider inputOrgid:', inputOrgid)
  console.log('DataProvider inputLoid:', inputLoid)

  React.useEffect(() => {
    if (inputOrgid === undefined || inputOrgid === null || inputOrgid === '') {
      setInputOrgid('1110')
    }
    if (inputLoid === undefined || inputLoid === null || inputLoid === '') {
      setInputLoid('62d26fb0')
    }
  }, [])

  return (
    <DataContext.Provider value={{ inputOrgid, setInputOrgid, inputLoid, setInputLoid }}>
      {children}
    </DataContext.Provider>
  )
}
